import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'shared-tasks-container',
  templateUrl: './tasks-container.task.html',
  styleUrls: ['./tasks-container.task.scss'],
  host: { class: 'tasks-container' },
})
export class SharedTasksContainerComponent implements OnInit {
  @Input() dependencyCount?: number;
  @Input() dependentOn?: string;

  showDelay = new UntypedFormControl(1000);
  hideDelay = new UntypedFormControl(1000);

  flexDeep!: string;
  constructor() {}

  ngOnInit(): void {
    if (this.dependencyCount && this.dependencyCount != 0) {
      this.flexDeep = `0 0 ${(this.dependencyCount - 1) * 18}px`;
    }
  }
}
